import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import FacebookSharpIcon from "@mui/icons-material/FacebookSharp";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import React from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/EYouth Logo W.webp";
import Egypt from "../../assets/EgyptFlag.webp";
import FotterRight from "../../assets/FooterRight.webp";
import FooterBottom from "../../assets/FullCircle.webp";
import UAEFlag from "../../assets/UAEFlag.webp";
import SAflag from "../../assets/SAflag.webp";
import iaoImage from '../../assets/logo IAO.png';
import MobileApplications from "../MobileApplications/MobileApplications";
import styles from "./footer.module.css";

export default function Footer() {
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation();

  return (
    <>
      {pathname !== "/signin" && pathname !== "/signup" && (
        <>

          <div className={styles.smallFooter}>
            <LazyLoadImage

              alt="icon"
              src={FotterRight}
              className={styles.imgRight}
            />
            <Link to="/Policy" className="me-3">{t('privacy_policy')} </Link>
            <Link to="/platform-policy">{t("Platform_policies")} </Link>
            <Link to="/terms-conditions">{t("Terms_and_conditions")} </Link>
            <Link to="/faq">{t("FAQ")} </Link>
            <Link to="/files/UserGuides.pdf" target="_blanck">{t("users_Guide")} </Link>
            <Link to="/files/EYouth_TOC_Final.pdf" className="me-3" target="_blanck">{t("EYouth_Theory_of_Change")} </Link>

          </div>
          <footer className={styles.footer_image}>

            <LazyLoadImage

              alt="icon"
              src={FooterBottom}
              className={styles.imgDown}
            />

            <div className={styles.first_footer_div}>
              <div className={` ${styles.aboutEyouth}`}>
                <h5 className="fw-bold my-4">
                  {t("footer_educational_platform")}
                </h5>
                <ul className={styles.footerMenu}>
                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <a
                      className="text-decoration-none my-2 text-white"
                      href="/all-courses?pacing=true"
                    >
                      {t("Interactive_Recorded_Courses")}
                    </a>
                  </li>
                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <a
                      className="text-decoration-none my-2 text-white"
                      href="/all-courses?pacing=false"
                    >
                      {t("LIVE_Courses")}
                    </a>
                  </li>
                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <Link
                      className="text-decoration-none my-2 text-white"
                      to="/instructors"
                    >
                      {t("Instructors")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className={`col-2 text-center ${styles.aboutEyouth}`}>
                <h5 className="fw-bold my-4 "> {t("footer_business")} </h5>
                <ul className="d-flex gap-2 flex-column align-items-center">
                  <li className={styles.button_trainee}>
                    <a href="https://business.eyouthlearning.com/">
                      {t("Train_your_business_team")}
                    </a>
                  </li>
                  <li className={styles.button_Join}>
                    <a href="https://www.eyouthlearning.com/studio">
                      {t("Join_EYouth_Instructors")}
                    </a>
                  </li>
                </ul>
              </div>
              <div className={`col-2 text-center ${styles.aboutEyouth}`}>
                <h5 className="fw-bold my-4 ">{t("Certificates")}</h5>
                <ul className={styles.footerMenu}>

                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <a
                      style={{ color: "white" }}
                      className="contact-us"
                      href="https://www.iao.org/Egypt-GizaGovernorate/EYouth"
                    >
                      {t("All our certificates are certified by")}
                    </a>
                  </li>
                  <li>
                    <img src={iaoImage} width="50%" alt="iao-logo" />
                  </li>
                </ul>

              </div>
              <div className={`col-4 ${styles.aboutEyouth}`}>
                <h5 className="fw-bold my-4  text-white">
                  <a className="text-white" href="/contact-us">
                    {t("footer_contact_info")}
                  </a>
                </h5>
                <ul className={styles.footerMenu}>
                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <CallIcon className="ms-1" />
                    <a
                      style={{ color: "white" }}
                      title="تواصل معنا"
                      className="contact-us"
                      href="/contact-us"
                    >
                      {t("footer_contact_us")}
                    </a>
                  </li>
                  <li className={`my-3 ${styles.footer_menu_li}`}>
                    <EmailIcon className="ms-1" />
                    <a
                      style={{ color: "white" }}
                      className="contact-us"
                      href="mailto:Support@eyouthlearning.com"
                    >
                      Support@eyouthlearning.com
                    </a>
                  </li>
                  <div className={` d-flex align-items-start my-3 ${styles.flag_div} `}>
                    <LazyLoadImage alt="icon" className="mx-2" src={Egypt} />
                    <li className={` ${styles.footer_menu_li}`}>
                      {t("footer_address-EGY")}
                    </li>
                  </div>
                  <div className={` d-flex align-items-start my-3 ${styles.flag_div} `}>
                    <LazyLoadImage alt="icon" className="mx-2" src={SAflag} />
                    <li className={` ${styles.footer_menu_li}`}>
                      {t("footer_address-SA")}
                    </li>
                  </div>
                  <div className={` d-flex align-items-start my-3 ${styles.flag_div} `}>
                    <LazyLoadImage alt="icon" className="mx-2" src={UAEFlag} />
                    <li className={`${styles.footer_menu_li}`}>
                      {t("footer_address-UAE")}
                    </li>
                  </div>
                </ul>
              </div>
              <div className={styles.log_div}>
                <LazyLoadImage

                  src={logo}
                  alt="eyouth-logo"
                  width=""
                  height=""
                  className={styles.logo_footer}
                />
                <MobileApplications />
                <div className="d-flex mt-4">
                  <div className={`ms-3 ${styles.iconSpan}`}>
                    <a
                      className="text-white"
                      href="https://www.facebook.com/EYouthLearning/"
                    >
                      <FacebookSharpIcon style={{ fontSize: "28.881px" }} />
                    </a>
                  </div>
                  <div className={`ms-3 ${styles.iconSpan}`}>
                    <a
                      className="text-white"
                      href="https://twitter.com/eyouthlearning?s=11&t=mLl8LMthDwW6RVwDg9BxDg"
                    >
                      <TwitterIcon style={{ fontSize: "28.881px" }} />
                    </a>
                  </div>
                  <div className={`ms-3 ${styles.iconSpan}`}>
                    <a
                      className="text-white"
                      href="https://www.linkedin.com/company/eyouth/mycompany/verification/"
                    >
                      <LinkedInIcon style={{ fontSize: "28.881px" }} />
                    </a>
                  </div>
                  <div className={`ms-3 ${styles.iconSpan}`}>
                    <a
                      className="text-white"
                      href="https://instagram.com/eyouthlearning?igshid=YmMyMTA2M2Y="
                    >
                      <InstagramIcon style={{ fontSize: "28.881px" }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className={`d-flex justify-content-around ${styles.lastFooter}`}>
              <div className="w-50 d-flex justify-content-around  ">
                <p className="text-white text-center">
                  {t("footer_contact_rights")}
                </p>
              </div>
            </div>
          </footer>
        </>
      )}
    </>
  );
}
